import { render, staticRenderFns } from "./PnrForm.vue?vue&type=template&id=1787ae5e&scoped=true&"
import script from "./PnrForm.vue?vue&type=script&lang=js&"
export * from "./PnrForm.vue?vue&type=script&lang=js&"
import style0 from "./PnrForm.vue?vue&type=style&index=0&id=1787ae5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787ae5e",
  null
  
)

export default component.exports